import {getElementFromSessionStorage, setElementToSessionStorage} from 'app/helpers/webStorageUtility';
import {windowIsDefined} from 'app/helpers/windowIsDefined';

const STORAGE_NAME = 'tickersLiked';

const getLikedTickers = () => {
  const storedTickersLiked = getElementFromSessionStorage(STORAGE_NAME);
  return storedTickersLiked ? JSON.parse(storedTickersLiked) : [];
};

const addTickerLikeToSessionStorage = id => {
  const tickersLiked = getLikedTickers();
  tickersLiked.push(id);
  setElementToSessionStorage(STORAGE_NAME, JSON.stringify(tickersLiked));
};

const removeTickerLikeFromSessionStorage = id => {
  const tickersLiked = getLikedTickers();
  const indexToRemove = tickersLiked.indexOf(id);
  if (indexToRemove === -1) {
    return;
  }
  tickersLiked.splice(indexToRemove, 1);
  setElementToSessionStorage(STORAGE_NAME, JSON.stringify(tickersLiked));
};

const getTickerLikeFromSessionStorage = id => {
  if (windowIsDefined) {
    const tickersLiked = getLikedTickers();
    return tickersLiked.includes(id);
  }
};

export {addTickerLikeToSessionStorage, removeTickerLikeFromSessionStorage, getTickerLikeFromSessionStorage};
